<astrobin-loading-indicator [hidden]="!!tilesLoaded"></astrobin-loading-indicator>

<div class="row g-0">
  <div class="col-10">
    <input
      [placeholder]="'Search for a location' | translate"
      class="form-control mb-3"
      [(ngModel)]="search"
      type="text"
    />
  </div>
  <div class="col-2">
    <button (click)="searchChanged($event)" class="btn btn-primary btn-block w-100">
      <fa-icon icon="search"></fa-icon>
    </button>
  </div>
</div>

<div #map style="width: 100%; height: {{ props.height }}px"></div>
